export default "__VITE_ASSET__Bf0izl0N__"